import AppAvatar from "./AppAvatar.vue";

export default {
  extends: AppAvatar
};
